import React, { useMemo, useState } from 'react';
import TemplateSelector from '../../Shared/Components/TemplateSelector/TemplateSelector';
import { BoardingPlaceTemplate } from '../../BoardingPlaceTemplates';
import { useGetBoardingPlaceTemplatesQuery } from '../../BoardingPlaceTemplates/Service/boardingPlaceTemplatesApi';
import { useAssignOfferBoardingPlaceTemplateMutation } from '../Service/extendedOfferBoardingPlacesApi';

interface BoardingPlaceTemplateSelectorWrapperProps {
  offerId: number;
  onSuccess?: () => void;
}

const BoardingPlaceTemplateSelectorWrapper = ({
  offerId,
  onSuccess,
}: BoardingPlaceTemplateSelectorWrapperProps) => {
  const {
    data: templatesData,
    isLoading,
    error: templatesError,
  } = useGetBoardingPlaceTemplatesQuery();

  // Mutacja przypisania szablonu do oferty
  const [assignTemplate, { isLoading: isAssigning, error: assignError }] =
    useAssignOfferBoardingPlaceTemplateMutation();
  // Wybrany szablon
  const [selectedId, setSelectedId] = useState<number | ''>('');

  const { templates, error } = useMemo(() => {
    const status = (templatesError as any)?.status;
    if (status === 404) {
      return { templates: [] as BoardingPlaceTemplate[], error: undefined };
    }

    return {
      templates: (templatesData ?? []) as BoardingPlaceTemplate[],
      error: templatesError,
    };
  }, [templatesData, templatesError]);

  const handleAssign = async () => {
    if (!selectedId) return;
    await assignTemplate({ offerId, templateId: Number(selectedId) }).unwrap();
    onSuccess?.();
  };

  return (
    <TemplateSelector
      templates={templates}
      isLoading={isLoading}
      error={error}
      selectedId={selectedId}
      setSelectedId={setSelectedId}
      isAssigning={isAssigning}
      assignTemplate={handleAssign}
      assignError={assignError}
      getName={(t) => t.name}
      placeholder="Wybierz szablon miejsc wsiadania"
      buttonLabel="Załaduj szablon"
    />
  );
};

export default BoardingPlaceTemplateSelectorWrapper;
